import enUs from './en_US';
import frFR from './fr_FR';
export default {
    en_US: enUs,
    fr_FR: frFR    
};



// WEBPACK FOOTER //
// ./src/translations/translations.js